export default {
  props: [
    {
      attr: 'projectName',
      name: '作品名称'
    },
    {
      attr: 'status',
      name: '作品状态',
      slot: 'status'
    },
    {
      attr: 'runQty',
      name: '被运行次数',
      sortable: true
    },
    {
      attr: 'likeQty',
      name: '被点赞次数',
      sortable: true
    },
    {
      attr: 'shareQty',
      name: '被分享次数',
      sortable: true
    },
    {
      attr: 'hotQty',
      name: '热度',
      sortable: true
    },
    {
      attr: 'createTime',
      name: '创建时间',
      slot: 'createTime',
      sortable: true
    }
  ]
}
